import React, { useEffect } from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useLocation } from "react-router";

const FinalPage = () => {
    const LOCAL_STORAGE_KEY1 = "investmentPreferenceProgress";
    const LOCAL_STORAGE_KEY2 = "riskProfileProgress";

    useEffect(() => {
        localStorage.removeItem(LOCAL_STORAGE_KEY1);
        localStorage.removeItem(LOCAL_STORAGE_KEY2);
    }, []);

    const location = useLocation<any>();
    const completePayload = location.state?.completionPayload;
    console.log(completePayload)
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                backgroundColor: "background.default",
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: 4,
                    borderRadius: 3,
                    textAlign: "center",
                }}
            >
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    color="primary"
                    gutterBottom
                >
                    Thank you for completing the assessment!
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Your RM will contact you.
                </Typography>
            </Paper>
        </Box>
    );
};

export default FinalPage;
